import RouteButton from 'components/buttons/routeButton'
import { getItem } from 'store/localeStorage'

export type ButtonsContainerProps = {
   size: string
   delay: number
   top?: string
   left?: string
   right?: string
   title: string
   titleForCrumb?: string
   titleColor: string
   page: string
   background: string
   border: string
   borderRadius: string
   bckType: string
   img?: string
   title2?: string
   title3?: string
   start?: boolean
}
export default function ButtonsContainer(props: any) {
   const { buttons } = props
   return (
      <div className={`buttonsContainer flex w100 wrap ${props.start ? 'flexStart' : 'center'}`}>
         {buttons.map((button: ButtonsContainerProps, index: number) => {
            if (button.page === '/accueil/projets') {
               if (!getItem('totem')) return null
            }
            return (
               <RouteButton
                  key={index + button.title}
                  size={button.size}
                  delay={button.delay}
                  top={button.top}
                  left={button.left}
                  right={button.right}
                  title={button.title}
                  titleForCrumb={button.titleForCrumb}
                  titleColor={button.titleColor}
                  page={button.page}
                  background={button.background}
                  border={button.border}
                  borderRadius={button.borderRadius}
                  bckType={button.bckType}
                  img={button.img}
                  title2={button.title2}
                  title3={button.title3}
               />
            )
         })}
      </div>
   )
}
